import { render } from "./SelectField.vue?vue&type=template&id=c977be9a"
import script from "./SelectField.vue?vue&type=script&lang=js"
export * from "./SelectField.vue?vue&type=script&lang=js"

import exportComponent from "/www/yadonor/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SelectField.vue"]])

export default __exports__